export default __webpack_public_path__ + "static/media/Ronnie.576a7bd6.png";